module.exports = __webpack_public_path__ + "img/5.0f0e1ae.png";